import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  open(event) {
    event.stopPropagation();
    const toggledItem = event.target;

    this.itemTargets.forEach((item) => {
      if (item !== toggledItem) {
        // Trigger close action on this item
        this.dispatch("close", { target: item });
      }
    });
  }
}
